import httpClient from '@/lib/httpClient.js'
import useAuthStore from '@/store/useAuthStore.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetCurrentUser(isAuthenticated = true) {
  const setUserData = useAuthStore((state) => state.setUserData)

  const fetchData = async () => {
    const response = await httpClient.get('/user')

    setUserData(response.data)
    return response.data
  }

  return useQuery({
    queryKey: ['current-user'],
    queryFn: fetchData,
    enabled: isAuthenticated,
  })
}
